import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Modal, ModalBody,
  Row,
} from 'reactstrap';

import Button from 'components/App/Button';

import INITIAL_VALUE from 'constants/initialValue';
import { PROMOTION_TYPE } from 'constants/promotion';
import { ROOM_TYPE } from 'constants/index';
import { convertIsoDateToString } from 'utils';

import images from 'assets/images';

import styles from './styles.module.scss';

function ModalPromotionSummarize(props) {
  const {
    isOpen,
    loading,
    isSimpleSummary,

    validation,
    roomOfPlaceList,
    placePriceTypes,

    onSubmit,
    onCloseClick,
  } = props;

  const getRoomLabel = React.useCallback((roomId) => {
    const room = roomOfPlaceList.find((item) => item._id === roomId);

    if (!room) return '';

    if (room.parentRoomName) {
      return ROOM_TYPE[room.parentRoomName]?.label;
    }

    return room.name;
  }, [roomOfPlaceList]);

  const renderDateBooking = React.useMemo(() => {
    switch (validation.values.discountType) {
      case PROMOTION_TYPE.LAST_DAY:
        return (
          <Row className={styles.Content}>
            <Col lg="5" className={styles.Label}>
              Thời gian đặt
            </Col>
            <Col lg="7" className={styles.Value}>
              {`${validation.values.maxLastDays} ngày hoặc ít hơn trước khi nhận phòng`}
            </Col>
          </Row>
        );

      case PROMOTION_TYPE.LONG_TERM:
        return (
          <Row className={styles.Content}>
            <Col lg="5" className={styles.Label}>
              Số đêm lưu trú
            </Col>
            <Col lg="7" className={styles.Value}>
              {`Tối thiểu ${validation.values.minStayNights} đêm`}
            </Col>
          </Row>
        );

      case PROMOTION_TYPE.BOOK_EARLY:
        return (
          <Row className={styles.Content}>
            <Col lg="5" className={styles.Label}>
              Thời gian đặt
            </Col>
            <Col lg="7" className={styles.Value}>
              {`${validation.values.minEarlyDays} ngày hoặc hơn`}
            </Col>
          </Row>
        );

      default:
        return null;
    }
  }, [validation.values]);

  return (
    <Modal
      size="lg"
      className={styles.Modal}
      isOpen={isOpen}
      toggle={onCloseClick}
      centered
    >
      <ModalBody className={styles.ModalBody}>
        <div className={styles.Header}>
          <button
            type="button"
            className={`btn btn__close ${styles.Btn}`}
            onClick={onCloseClick}
            aria-label="Close modal"
          >
            <div className="image-wrapper">
              <img src={images.modalClose.default} alt="" className="img-fluid img-close" />
            </div>
          </button>
        </div>

        <div className={styles.BodyWrapper}>
          <div className={styles.Body}>
            <h3>Xem lại khuyến mãi</h3>
            <p>
              Sau khi Bạn nhấp vào kích hoạt, khách trên Bookese.com sẽ thấy được khuyến mãi này.
              Bạn có thể chỉnh sửa bất cứ chi tiết nào ở đây hoặc trên trang &quot;Khuyến mãi&quot;.
            </p>
          </div>

          <div className={styles.ContentWrapper}>
            <Row className={styles.Content}>
              <Col lg="5" className={styles.Label}>
                Thông tin chi tiết về khuyến mãi
              </Col>
              <Col lg="7" className={styles.Value}>
                {`Giảm giá ${validation.values.discountRate}%`}
              </Col>
            </Row>

            {!isSimpleSummary && (
              <>
                {renderDateBooking}

                <Row className={styles.Content}>
                  <Col lg="5" className={styles.Label}>
                    Loại giá và phòng
                  </Col>
                  <Col lg="7" className={styles.Value}>
                    {validation.values.isAllPriceTypes
                      ? <p>Tất cả loại giá</p>
                      : (
                        <p>
                          {`Loại giá áp dụng: ${validation.values.priceTypes
                            .map((item) => placePriceTypes.find(
                              (priceType) => (priceType._id === item),
                            )?.name).join(', ')}`}
                        </p>
                      )}

                    {validation.values.isAllRooms
                      ? <p>Tất cả phòng</p>
                      : (
                        <p className="mb-0">
                          {`Phòng áp dụng: ${validation.values.rooms
                            .map(getRoomLabel).join(', ')}`}
                        </p>
                      )}

                  </Col>
                </Row>
                <Row className={styles.Content}>
                  <Col lg="5" className={styles.Label}>
                    Thời gian đặt
                  </Col>
                  <Col lg="7" className={styles.Value}>
                    {`${convertIsoDateToString(validation.values.bookingStartAt, 'D [tháng] M yyyy')} – ${convertIsoDateToString(validation.values.bookingEndAt, 'D [tháng] M yyyy')}`}
                  </Col>
                </Row>
                <Row className={styles.Content}>
                  <Col lg="5" className={styles.Label}>
                    Ngày lưu trú
                  </Col>
                  <Col lg="7" className={styles.Value}>
                    {validation.values.stayAt.map(
                      (item, idx) => <span key={item.id}>{`${idx > 0 ? ', ' : ''}${convertIsoDateToString(item.startAt, 'D [tháng] M yyyy')} – ${convertIsoDateToString(item.endAt, 'D [tháng] M yyyy')}`}</span>,
                    )}
                  </Col>
                </Row>
              </>
            )}

            <Row className={styles.Content}>
              <Col lg="5" className={styles.Label}>
                Tên khuyến mãi
              </Col>
              <Col lg="7" className={styles.Value}>
                {validation.values.name}
              </Col>
            </Row>
          </div>

          <div className={styles.Footer}>
            <Button
              classes={`${styles.Button} ${styles.ButtonCancel}`}
              onClick={onCloseClick}
            >
              Hủy
            </Button>

            <Button classes={`${styles.Button} ${styles.ButtonSave}`} onClick={onSubmit} loading={loading}>
              Lưu
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

ModalPromotionSummarize.propTypes = {
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  isSimpleSummary: PropTypes.bool,

  validation: PropTypes.instanceOf(Object),
  roomOfPlaceList: PropTypes.instanceOf(Array),
  placePriceTypes: PropTypes.instanceOf(Array),

  onCloseClick: PropTypes.func,
  onSubmit: PropTypes.func,
};

ModalPromotionSummarize.defaultProps = {
  isOpen: false,
  loading: false,
  isSimpleSummary: false,

  validation: INITIAL_VALUE.OBJECT,
  roomOfPlaceList: INITIAL_VALUE.ARRAY,
  placePriceTypes: INITIAL_VALUE.ARRAY,

  onCloseClick: INITIAL_VALUE.FUNCTION,
  onSubmit: INITIAL_VALUE.FUNCTION,
};

export default memo(ModalPromotionSummarize);
